import { default as createStore } from './createStore';
// TODO domyslet full override reducers
import { default as reducers } from './reducers';
import { combineReducers, ReducersMapObject } from 'redux';

export default createStore(combineReducers(reducers as any as ReducersMapObject<any>));
